import React, { useEffect, useState } from "react";
import moment from "moment";
import ToastUtil from "../../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../../components/SweetAlert";
import "./styles.css";

const MultipleShiftSelect = ({
  featuresOnOff,
  setFeaturesOnOff,
  masterClockInOutHandler,
  timeClockType,
  setSelectedSchedule,
  activeSchedules,
  setFeatures,
}) => {
  const [assignedShift, setAssignedShift] = useState([]);
  const [selectedShift, setSelectedShiftState] = useState(null); // Track the selected shift separately

  // Update assignedShift when activeSchedules change
  useEffect(() => {
    if (activeSchedules.length > 0) {
      const assignedSchedule = activeSchedules.filter(
        (schedule) => schedule.status
      );
      setAssignedShift(assignedSchedule);
    }
  }, [activeSchedules]);

  // Run masterClockInOutHandler **only when selectedShift updates**
  useEffect(() => {
    if (selectedShift) {
      setTimeout(() => {
        masterClockInOutHandler(timeClockType);
      }, 2000);
    }
  }, [selectedShift]); // This ensures masterClockInOutHandler runs **after** state updates

  const setSelectedScheduleHandler = async (shift) => {
    if (
      await AlertService.confirm(
        `${shift.shift} ${moment(shift.start_time, "HH:mm:ss").format(
          "hh:mma"
        )} - ${moment(shift.end_time, "HH:mm:ss").format("hh:mma")}`,
        `Are you sure you want to select this shift?`
      )
    ) {
      setSelectedSchedule(shift);
      setSelectedShiftState(shift); // Store the shift in local state first
      setFeaturesOnOff({ feature: null });

      setFeatures((prev) =>
        prev.map((item) =>
          item.feature === "selectMultipleShift"
            ? { ...item, trail: true }
            : item
        )
      );

      ToastUtil.success("Shift selected successfully!");
    }
  };

  return (
    <React.Fragment>
      {featuresOnOff.feature === "selectMultipleShift" && (
        <div className="timeclock__shift-container">
          <h5 className="mb-2 text-muted">Select Shift</h5>
          <p className="text-muted">
            Since you have been assigned to multiple different shifts.
          </p>

          {assignedShift.map((shift, index) => {
            let condition =
              timeClockType === "clock out"
                ? !(
                    [2, 3, 4, 5].includes(shift.status) &&
                    shift.time_out === null &&
                    shift.time_in !== null
                  )
                : [2, 3, 4, 5].includes(shift.status) &&
                  shift.time_out !== null;

            return (
              <button
                key={index}
                type="button"
                className="btn btn-design btn-shift"
                onClick={() => setSelectedScheduleHandler(shift)}
                disabled={condition}
                style={{
                  backgroundColor: condition ? "#ccc" : "transparent",
                  opacity: condition ? 0.5 : 1,
                }}
              >
                {`${shift.shift} ${moment(shift.start_time, "HH:mm:ss").format(
                  "hh:mma"
                )} - ${moment(shift.end_time, "HH:mm:ss").format("hh:mma")} ${
                  [2, 3, 4, 5].includes(shift.status) && shift.time_out !== null
                    ? "- Completed"
                    : ""
                }`}
              </button>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default MultipleShiftSelect;
